import type { ColumnFiltersState } from '@tanstack/react-table';
import type { DiscountRateScenarioParams } from './atoms';

export const DEFAULT_PARAMS: DiscountRateScenarioParams = {
  page: 1,
  pageSize: 100,
  sortAttribute: 'created_at',
  sortDirection: 'DESC',
};

export const SORT_FIELD_MAP: Record<string, string> = {
  name: 'name',
  effectiveDate: 'effective_date',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};

/**
 * Converts DataTable column filter state to query params for the DRS list API.
 * @param {ColumnFiltersState} filters - The column filter state from the DataTable
 * @return {Partial<DiscountRateScenarioParams>} The query params for the API
 */
export const columnFiltersToParams = (
  filters: ColumnFiltersState
): Partial<DiscountRateScenarioParams> => {
  const params: Partial<DiscountRateScenarioParams> = {
    createdBy: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    effectiveDate: undefined,
  };

  for (const filter of filters) {
    switch (filter.id) {
      case 'createdBy':
        params.createdBy = filter.value as string[];
        break;
      case 'createdAt': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.createdAt =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
      case 'updatedAt': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.updatedAt =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
      case 'effectiveDate': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.effectiveDate =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
    }
  }

  return params;
};
